<style scoped>

.projects {
    margin-top: 30px;
}

</style>

<template>
<div class="projects">
    <v-container fluid grid-list-lg grid-list-md>
        <v-layout row wrap style="position: relative">
    <v-flex xs3 sm3  v-for="(item, index) in connections" :key="index">
            <v-card  style="padding: 10px" >
                <div>
                  <img alt="" :src="item.src">
                </div>
                  <span class='text--primary'>{{ item.name }}</span> <br />

                  <v-list-tile-sub-title>
                      {{ item.description }}
                  </v-list-tile-sub-title>
            </v-card>
    </v-flex>
  </v-layout>
    </v-container>
</div>

</template>

<script>

import ProjectItem from '@/components/ProjectItem.vue'
import {createNamespacedHelpers} from 'vuex'
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('projects')
export default {
    name: 'projects',
    data: function() {
        return {

          connections: [
            {name: "Athena", description: "", src: "/assets/icons/plugins/athena/icons/athena_icon_big.png"},
            {name: "Azure", description: "", src: "/assets/icons/plugins/mssql/icons/azure_icon_big.png"},
            {name: "MariaDB", description: "", src: "/assets/icons/plugins/mysql/icons/mariadb_icon_big.png"},
            {name: "MySQL", description: "", src: "/assets/icons/plugins/mysql/icons/mysql_icon_big.png"},
            {name: "Presto DB", description: "", src: "/assets/icons/plugins/generic/icons/presto_icon_big.png"},
            {name: "MsSQL", description: "", src: "/assets/icons/plugins/mssql/icons/mssql_icon_big.png"},
            {name: "SyBase", description: "", src: "/assets/icons/plugins/mssql/icons/sybase_icon_big.png"},
            {name: "PostrgeSQL", description: "", src: "/assets/icons/plugins/postgresql/icons/postgresql_icon_big.png"},
            {name: "Cocroach DB", description: "", src: "/assets/icons/plugins/postgresql/icons/cockroach_icon_big.png"},
            {name: "Timescale", description: "", src: "/assets/icons/plugins/postgresql/icons/timescale_icon_big.png"},
            {name: "Redshift", description: "", src: "/assets/icons/plugins/postgresql/icons/redshift_icon_big.png"},
            {name: "Yellow Brock", description: "", src: "/assets/icons/plugins/postgresql/icons/yellowbrick_icon_big.png"}
          ]
        }
    },
    components: {
        'project-item': ProjectItem
    },
    computed: {
      ...mapState(['projects', 'project', 'dialog'])
    },
    methods: {
      ...mapMutations(['mAdd', 'mCloseDialog']),
      ...mapActions(['aAdd', 'aInit']),
      submit() {
        const add = this.aAdd;
        const project = this.project;
        this.$validator.validateAll().then(function(response) {
          if(response === true) { add(project); }
        }).catch(function(e) {});
      }
    },
    mounted: function() {
      this.aInit();
    }
}

</script>
